import { envConfig } from "../../utils/constants";
import {
  OrderInformationState,
  PaymentState,
} from "../../utils/interfaces/payment";
import { client } from "../graphql";
import { CANCEL_ORDER, PLACE_ORDER, SET_PAYMENT_METHOD } from "./mutations";
import { GET_PAYMENT_CONFIG, ORDER_CONFIRMATION } from "./queries";

class PaymentServices {
  async getPaymentConfig(): Promise<PaymentState> {
    const res = await client.query({
      query: GET_PAYMENT_CONFIG,
      context: { headers: { store: envConfig.store } },
    });
    return res.data.storeConfig;
  }

  async setPaymentMethod(cart_id: string): Promise<any> {
    const res = await client.mutate({
      mutation: SET_PAYMENT_METHOD,
      variables: { cart_id },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.setPaymentMethodOnCart;
  }

  async placeOrder(cart_id: string): Promise<any> {
    const res = await client.mutate({
      mutation: PLACE_ORDER,
      variables: { cart_id },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.placeOrder;
  }

  async fetchOrderDetails(orderId: string): Promise<OrderInformationState> {
    const res = await client.query({
      query: ORDER_CONFIRMATION,
      variables: { orderId },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.orderInformation;
  }

  async cancelOrder(order_id: string): Promise<any> {
    const res = await client.mutate({
      mutation: CANCEL_ORDER,
      variables: { order_id },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.cancelOrderAndRestoreQuote;
  }
}

export default new PaymentServices();
